document.documentElement.classList.remove('no-js');

(function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var close = document.querySelector('[data-mobile-nav-close]');
  var backdrop = document.querySelector('[data-mobile-nav-backdrop]');
  var nav = document.getElementById('MobileNav');
  if (!toggle || !nav) return;

  function openNav() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openNav);
  if (close) close.addEventListener('click', closeNav);
  if (backdrop) backdrop.addEventListener('click', closeNav);

  window.addEventListener('resize', function () {
    if (window.innerWidth > 989) closeNav();
  });

  var submenuToggles = nav.querySelectorAll('[data-mobile-submenu-toggle]');
  submenuToggles.forEach(function (btn) {
    var item = btn.closest('.mobile-nav__item');
    var submenu = item ? item.querySelector('.mobile-nav__submenu') : null;
    if (!submenu) return;
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      submenuToggles.forEach(function (otherBtn) {
        if (otherBtn === btn) return;
        var otherItem = otherBtn.closest('.mobile-nav__item');
        var otherSubmenu = otherItem ? otherItem.querySelector('.mobile-nav__submenu') : null;
        otherBtn.setAttribute('aria-expanded', 'false');
        if (otherSubmenu) otherSubmenu.hidden = true;
      });
      btn.setAttribute('aria-expanded', String(!isOpen));
      submenu.hidden = isOpen;
    });
  });
})();

(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var lastY = window.scrollY;
  var revealThreshold = header.offsetHeight;
  var minDelta = 5;

  window.addEventListener('scroll', function () {
    var y = Math.max(window.scrollY, 0);
    if (document.body.style.overflow === 'hidden') {
      lastY = y;
      return;
    }
    if (y <= revealThreshold) {
      header.classList.remove('site-header--hidden');
      lastY = y;
      return;
    }
    if (Math.abs(y - lastY) < minDelta) return;
    if (y < lastY) {
      header.classList.remove('site-header--hidden');
    } else {
      header.classList.add('site-header--hidden');
    }
    lastY = y;
  }, { passive: true });
})();

// Keep the header cart count in sync after a form-based add-to-cart
// (product/cart pages submit normally; this just guards against bfcache staleness).
window.addEventListener('pageshow', function (event) {
  if (event.persisted) window.location.reload();
});
